<template>
  <div>
    <div v-if="billingMethod.id < 1" class="new-billing-method">
      <div class="delete-billing-method">
        <font-awesome-icon
          icon="times"
          class="billing-method-close"
          @click="deleteNewBillingMethod()"
        />
      </div>
      <DropdownSelect
        :menu-items="billingMethodModes"
        :selected-item="newBillingMethod.created_comment"
        class="blue"
        @select-item="updateBillingMethodMode"
      />
      <DropdownSelect
        v-if="newBillingMethod.created_comment === 'None'"
        :menu-items="billingMethodTypes"
        :selected-item="selectedBillingMethodType(newBillingMethod.type)"
        class="blue"
        @select-item="updateBillingMethodType"
      />
      <div v-if="newBillingMethod.type !== 'Type'">
        <TolTypeAhead
          v-show="true"
          :search-params="{
            url: '/client-contact/user-quick-search',
            searchKeys: ['username', 'first_name', 'last_name', 'email'],
            client_id: newBillingMethod.client_id
          }"
          class="blue contact-box"
          :menu-label="selectedContact"
          @select-item="OnContactSelect($event)"
        >
          <template v-slot="{ value }">
            {{ value.last_name }}, {{ value.first_name }}
          </template>
        </TolTypeAhead>

        <InputField
          v-model="newBillingMethod.attention"
          menu-label="Attention"
          type="text"
          name="attention"
          class="form-input"
          @change="updateBillingMethod"
        />
        <TolTypeAhead
          v-if="newBillingMethod.type === 'PAPER_MAIL' && newBillingMethod.clientAddress === ''"
          :search-params="{
            store: 'getClientDetailsAddressList',
            searchKeys: ['line1', 'city', 'postal_code']
          }"
          class="blue contact-box"
          :store-search="true"
          menu-label="Client Address"
          @select-item="OnAddressSelect($event)"
        >
          <template v-slot="{ value }">
            {{ value.line1 }}, {{ value.city }}
          </template>
        </TolTypeAhead>
        <div v-else-if="newBillingMethod.type === 'PAPER_MAIL'" class="billing-method-box">
          <div class="delete-billing-method">
            <font-awesome-icon
              icon="times"
              class="billing-method-close"
              @click="resetBillingMethod()"
            />
          </div>
          <tol-address :address="newBillingMethod.clientAddress" class="address" />
        </div>
        <InputField
          v-else-if="newBillingMethod.type === 'EMAIL'"
          v-model="newBillingMethod.email"
          menu-label="Email ID"
          name="email"
          type="text"
          class="form-input"
          @change="updateBillingMethod"
        />
        <InputField
          v-else
          v-model="newBillingMethod.other"
          menu-label="Comment"
          type="text"
          class="form-input"
          @change="updateBillingMethod"
        />
      </div>
      <div>
        <Checkbox size="tiny" :checked="newBillingMethod.is_default" @change="onSelect" />
        Default
      </div>
    </div>
    <div v-else :class="getDefaultColor">
      <div v-if="billingMethod.type == 'PAPER_MAIL'" class="billing-method">
        <div class="delete-billing-method">
          <font-awesome-icon
            icon="times"
            class="billing-method-close"
            @click="deleteBillingMethod()"
          />
        </div>
        <router-link
          v-if="billingMethod.user"
          :to="`/client-contacts/${billingMethod.user.referenceNumber}`"
        >
          {{ getDisplayName }}
        </router-link>
        <label v-else class="bold">{{ billingMethod.attention }}</label>

        <tol-address v-if="billingMethod.address" :address="billingMethod.address" />
      </div>
      <div v-else-if="billingMethod.type == 'EMAIL'" class="billing-method-other">
        <div class="delete-billing-method">
          <font-awesome-icon
            icon="times"
            class="billing-method-close"
            @click="deleteBillingMethod()"
          />
        </div>
        <div v-if="billingMethod.user">
          <router-link :to="`/client-contacts/${billingMethod.user.referenceNumber}`">
            {{ getDisplayName }}
          </router-link>
          <div>
            <label>{{ billingMethod.email }}</label>
          </div>
        </div>
        <label v-else class="bold">{{ getAttention }}</label>
        <div v-if="!billingMethod.user">
          <label>{{ billingMethod.email }}</label>
        </div>
      </div>
      <div v-else class="billing-method-other">
        <div class="delete-billing-method">
          <font-awesome-icon
            icon="times"
            class="billing-method-close"
            @click="deleteBillingMethod()"
          />
        </div>
        <router-link
          v-if="billingMethod.user"
          :to="`/client-contacts/${billingMethod.user.referenceNumber}`"
        >
          {{ getDisplayName }}
        </router-link>
        <label v-else class="bold">{{ billingMethod.attention }}</label>
        <div>
          <label>{{ billingMethod.other }}</label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ClientDetailsActions } from '@/app/features/clients/features/client-details/client-details.keys';
import InputField from '@/app/components/InputField';
import Checkbox from '@/app/components/Checkbox';
import DropdownSelect from '@/app/components/DropdownSelect';
import TolTypeAhead from '@/app/components/TolTypeAhead';
import TolAddress from '@/app/components/TolAddress';
import { AppGetters } from '@/app/app.keys';
import * as R from 'ramda';
export default {
  name: 'TolBillingMethod',
  components: {
    InputField,
    DropdownSelect,
    TolTypeAhead,
    TolAddress,
    Checkbox
  },
  props: {
    billingMethod: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      isOnScreenDataModified: false,
      billingMethodModes: ['Ariba', 'Fieldglass', 'None'],
      billingMethodTypes: ['Paper Mail', 'Email', 'Other'],
      selectedContact: 'Client Contact',
      newBillingMethod: {
        id: this.billingMethod.id,
        type: 'Paper Mail',
        attention: 'Attention',
        email: 'Email',
        other: 'Other',
        is_default: false,
        address_id: 0,
        user_id: 0,
        client_id: 0,
        created_comment: ''
      },
      currentMouseOver: ''
    };
  },
  computed: {
    provinceAbbrs() {
      return this.$store.getters[AppGetters.ProvinceAbbreviations];
    },
    billingMethodContact() {
      return this.billingMethod.attention ? this.billingMethod.attention : this.billingMethod.user;
    },
    selectedBillingMethodContact() {
      return this.selectedContact;
    },
    getDefaultColor() {
      return this.newBillingMethod.is_default ? 'default-billing-method' : '';
    },
    getAttention() {
      return this.billingMethod.attention
        ? this.billingMethod.attention
        : this.billingMethod.user.firstName.concat(' ', this.billingMethod.user.lastName);
    },
    getDisplayName() {
      return this.billingMethod.user.firstName.concat(' ', this.billingMethod.user.lastName);
    }
  },
  watch: {
    billingMethod: {
      immediate: true,
      handler() {
        this.newBillingMethod = R.clone(this.billingMethod);
      }
    }
  },
  methods: {
    deleteBillingMethod() {
      this.$emit('delete', this.billingMethod);
    },
    deleteNewBillingMethod() {
      this.$emit('delete', this.newBillingMethod);
    },
    updateBillingMethod() {
      this.$emit('update', this.newBillingMethod);
    },
    updateBillingMethodType(event) {
      event = event === 'Paper Mail' ? 'PAPER_MAIL' : event.toUpperCase();
      this.newBillingMethod.type = event;
      this.updateBillingMethod();
    },
    OnContactSelect(event) {
      this.newBillingMethod.attention = event.first_name + ' ' + event.last_name;
      this.newBillingMethod.user_id = event.id;
      this.newBillingMethod.clientAddress = event.address;
      this.newBillingMethod.email = event.email;
      this.newBillingMethod.address_id = event.address_id;
      this.updateBillingMethod();
    },
    OnAddressSelect(event) {
      this.newBillingMethod.clientAddress = event;
      this.newBillingMethod.address_id = event.id;
      this.updateBillingMethod();
    },
    resetBillingMethod() {
      this.newBillingMethod.clientAddress = '';
      this.newBillingMethod.address_id = 0;
      this.newBillingMethod.attention = 'Attention';
      this.newBillingMethod.user_id = 0;
      this.newBillingMethod.email = 'Email';
      this.updateBillingMethod();
    },
    selectedBillingMethodType(preference) {
      if (preference === 'PAPER_MAIL' || preference === 'EMAIL') {
        return preference === 'PAPER_MAIL' ? 'Paper Mail' : 'Email';
      } else if (preference === 'OTHER') {
        return 'Other';
      } else {
        return preference;
      }
    },
    onSelect() {
      this.newBillingMethod.is_default = !this.newBillingMethod.is_default;
      this.$store.dispatch(
        ClientDetailsActions.UpdateClientDefaultBillingMethod,
        this.newBillingMethod.id
      );
    },
    getTooltipDisplayContent(element) {
      this.currentMouseOver = element;
    },
    updateBillingMethodMode(event) {
      this.newBillingMethod.created_comment = event;
      if (event != 'None') {
        this.newBillingMethod.type = 'OTHER';
        this.newBillingMethod.other = event;
        this.newBillingMethod.email = null;
        this.updateBillingMethod();
      } else {
        this.newBillingMethod.attention = null;
        this.newBillingMethod.other = null;
        this.newBillingMethod.type = 'Type';
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/app/styles/colors.scss';

.billing-method {
  margin-bottom: 20px;
  border: 1px solid $light-grey-1;
  padding: 10px;
  flex-basis: 25%;
  width: 200px;
  height: 150px;
}
.billing-method-other {
  margin-bottom: 20px;
  border: 1px solid $light-grey-1;
  padding: 10px;
  flex-basis: 25%;
  width: 200px;
  height: 150px;
}
.new-billing-method {
  margin-bottom: 20px;
  border: 1px solid $light-grey-1;
  padding: 10px;
  flex-basis: 25%;
  width: 200px;
}
.delete-billing-method {
  display: flex;
  justify-content: flex-end;
}
.form-input {
  border-bottom: 1px solid $blue;
  font-size: 1em;
}
.billing-method-close {
  color: $red;
  cursor: pointer;
}
.contact-box {
  margin-top: 5px;
}
.billing-method-box {
  margin: 5px;
}
.bold {
  font-weight: bold;
}
.default-billing-method {
  background-color: $light-grey-1;
}
</style>
